import "bootstrap/dist/css/bootstrap.min.css";
import Detail from "./pages/detail";
import "./App.css";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import Home from "./pages/landing";
import Add from "./pages/addProduct";
import List from "./pages/listProduct";
import Admin from "./pages/admin";
import Profile from "./pages/profile";
import Cart from "./pages/cart";
import Edit from "./pages/update";
import "./assets/styles.css";
import { useContext, useEffect } from "react";
import { API, setAuthToken } from "./config/api";
import { UserContext } from "./context/userContext";

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

function App() {
  let navigate = useNavigate();

  const [state, dispatch] = useContext(UserContext);

  useEffect(() => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }
    
     else {
      if (state.user.status === "admin") {
        navigate("/admin");
      } else if (state.user.status === "customer") {
        navigate("/");
      }
    }
  }, [state]);

  const checkUser = async () => {
    try {
      const response = await API.get("/log-check");

      // If the token incorrect
      if (response.status === 404) {
        return dispatch({
          type: "AUTH_ERROR",
        });
      }

      // Get user data
      let payload = response.data.data;
      // Get token from local storage
      payload.token = localStorage.token;

      // Send data to useContext
      dispatch({
        type: "USER_SUCCESS",
        payload,
      });
    } catch (error) {
    }
  };

  useEffect(() => {
    if (localStorage.token) {
      checkUser();
    }
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/product/:id" element={<Detail />} />
        <Route exact path="/admin" element={<Admin />} />
        <Route exact path="/add-product" element={<Add />} />
        <Route exact path="/edit-product/:id" element={<Edit />} />
        <Route exact path="/profile" element={<Profile />} />
        <Route exact path="/list" element={<List />} />
        <Route exact path="/cart" element={<Cart />} />
      </Routes>
    </div>
  );
}

export default App;
